import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.load()
  }

  load() {
    fetch(this.urlValue, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'  // Add this header
      }
    })
      .then(response => response.text())
      .then(html => {
        this.element.innerHTML = html

        const firstChild = this.element.firstElementChild
        if (firstChild) {
          // This grabs all the existing controllers if present and adds remount to data-controller
          firstChild.dataset.controller = [firstChild.dataset.controller, 'remount']
            .filter(Boolean)
            .join(' ')
        }
      })
  }
}
